import React from 'react';

import PropTypes from 'prop-types';
import _ from 'lodash';
import { Button } from '@telus-uds/components-web';
import Delete from '@telus-uds/palette-allium/build/web/icons/Delete';

import { useLocalizedStringsContext } from '../../../../context/LocalizedStringsContext';
import { TankDetail, TankDetailRow, TankDetailRowKey } from './css';

const InfoListRow = ({
  typeKey,
  row,
  rowIndex = 0,
  tankDetailsFarmAndRanch = {},
  setTankDetailsFarmAndRanch = () => {},
  showDelete = true
}) => {
  const {
    iotOrderDetailsSection: { nssFarmAndRanchTankDetailsLabel }
  } = useLocalizedStringsContext();

  const dataObject = Object.entries(row)
    .reduce((acc, [key, value]) => {
      const label = key.replace('valueT', 't');
      let fieldValue = value;
      if (fieldValue === 'Other') fieldValue = row[`${key}Other`];

      return [
        ...acc,
        {
          label: _.get(nssFarmAndRanchTankDetailsLabel, label, '').replace(
            '*',
            ''
          ),
          value: fieldValue
        }
      ];
    }, [])
    .filter(rowData => !!rowData.label && !!rowData.value);

  const removeVehicleInfo = () => {
    const tankDetailsCopy = [...tankDetailsFarmAndRanch[typeKey]];
    tankDetailsCopy.splice(rowIndex, 1);
    setTankDetailsFarmAndRanch({
      ...tankDetailsFarmAndRanch,
      [typeKey]: tankDetailsCopy
    });
  };

  return (
    <TankDetail>
      <TankDetailRowKey>
        <p style={{ fontWeight: '700', fontSize: '24px' }}>#{rowIndex + 1}</p>
        {showDelete && (
          <div style={{ cursor: 'pointer' }}>
            <Button
              icon={Delete}
              onPress={removeVehicleInfo}
              accessibilityLabel="Delete"
              variant={{ text: true }}
            />
          </div>
        )}
      </TankDetailRowKey>
      <div style={{ padding: '0.5rem' }}>
        {dataObject.map(({ label, value }, index) => (
          <TankDetailRow isLastRow={index === dataObject.length - 1}>
            <p style={{ fontWeight: '700' }}>{label}</p>
            <p>{value}</p>
          </TankDetailRow>
        ))}
      </div>
    </TankDetail>
  );
};

InfoListRow.propTypes = {
  showDelete: PropTypes.bool,
  typeKey: PropTypes.string.isRequired,
  row: PropTypes.shape({
    valueTankNumber: PropTypes.string,
    valueTankName: PropTypes.string,
    valueTankProduct: PropTypes.string,
    valueTankProductOther: PropTypes.string,
    valueTankType: PropTypes.string,
    valueTankHeight: PropTypes.string,
    valueTankLength: PropTypes.string,
    valueTankCapacity: PropTypes.string,
    valueTankMaterial: PropTypes.string,
    valueTankMaterialOther: PropTypes.string,
    valueTankSensorType: PropTypes.string,
    valueTankPortSize: PropTypes.string,
    valueTankPortSizeOther: PropTypes.string,
    valueTankOptionalStand: PropTypes.string
  }).isRequired,
  rowIndex: PropTypes.number,
  tankDetailsFarmAndRanch: PropTypes.shape({
    fuelGauge: PropTypes.arrayOf(PropTypes.shape({})),
    fuelPressure: PropTypes.arrayOf(PropTypes.shape({})),
    propane: PropTypes.arrayOf(PropTypes.shape({}))
  }),
  setTankDetailsFarmAndRanch: PropTypes.func
};

export default InfoListRow;
